"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountSelectView = void 0;
var React = _interopRequireWildcard(require("react"));
var _AccountSelectContainer = require("./containers/AccountSelectContainer");
var _HelpContainer = require("../HelpContainer");
var _tracking = require("./tracking");
var _AccountSelectViewLayout = require("../../components/AccountSelectViewLayout");
var _uiKit = require("@cian/ui-kit");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AccountSelectView = _ref => {
  let {
    source
  } = _ref;
  React.useEffect(() => {
    (0, _tracking.trackAccountSelectOpen)(source);
  }, []);
  const handleHelpClick = React.useCallback(() => (0, _tracking.trackAccountSelectNeedHelp)(source), [source]);
  return /*#__PURE__*/React.createElement(_AccountSelectViewLayout.AccountSelectViewLayout, {
    title: /*#__PURE__*/React.createElement(_uiKit.UIHeading2, null, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442"),
    content: /*#__PURE__*/React.createElement(_AccountSelectContainer.AccountSelectContainer, null),
    help: /*#__PURE__*/React.createElement(_HelpContainer.HelpContainer, {
      indent: "L",
      onClick: handleHelpClick
    })
  });
};
exports.AccountSelectView = AccountSelectView;